import React from 'react'
import SupplyBillPaymentTable from './SupplyBillPaymentTable'
import SupplyBillPaymentButton from './forms/billPaymentForm/SupplyBillPaymentButton'
import { useSelector } from 'react-redux'

const SupplyBillPayments = ({ supplyBillId, billPayments }) => {

	const supplyBill = useSelector(state => state.supplyBill.supplyBill)

  return (
    <div>
        <h4>Оплати</h4>

		{
			supplyBill && supplyBill.payments && supplyBill.payments.length > 0 ?
				''
			:
				<SupplyBillPaymentButton 
					supplyBillId={supplyBillId}
				/>
		}

        <SupplyBillPaymentTable 
			supplyBillId={supplyBillId}
            // billPayments={billPayments}
        />
    </div>
  )
}

export default SupplyBillPayments